import {SET_DIRTY} from '../actions/dirty';

const defaultState = {};

export default function dirty(state = defaultState, action) {
    switch (action.type) {
        case SET_DIRTY: {
            const newState = {...state};
            if (action.dirty) {
                newState[action.windowId] = true;
            } else {
                delete newState[action.windowId];
            }
            return newState;
        }
        default:
            return state;
    }
}
